import React, { useState, useEffect, useContext, useRef } from "react";
import { Card, Button, Row, Container } from "react-bootstrap";
import Footer from "./Footer";
import Nav from "./Navbar";
import seobixBg from "../Images/authorbg.png";
import {
  BASE_URL_API_TRANXT_UAT_API,
  BASE_URL_API_TRANX_BLOG,
} from "../Utils/Constant";
import { basicauth, basicauthblog } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

const Author = () => {
  const { post_slug } = useParams();

  const blogSectionRef = useRef(null);
  const scrollToBlogs = () => {
    if (blogSectionRef.current) {
      blogSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const { password, username } = basicauthblog;
  const base64Credentials = btoa(`${username}:${password}`);
  const [Blogdata, setBlogdata] = useState([]);
  const [loading, setLoading] = useState(false);

  const [authorData, setAuthorData] = useState(null);
  const GetBlogsByAuthors = async (authorSlug) => {
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ author_slug: authorSlug, webid: "1" }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANX_BLOG}/GetBlogsByAuthors`,
        requestOptions
      );
      const data = await res.json();
      console.log("GetBlogsByAuthors response:", data);

      if (data.status === "0") {
        const authorInfo = data.data[0];
        setAuthorData({
          name: authorInfo.author_name,
          image: authorInfo.author_image,
        });
        // const filteredPosts = authorInfo.posts.filter(
        //   (post) => post.product_name === "seobix"
        // );
        setBlogdata(authorInfo.posts || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("Error fetching blogs:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (post_slug) {
      GetBlogsByAuthors(post_slug);
    } else {
      const author = localStorage.getItem("author");
      if (author) {
        const parsedAuthor = JSON.parse(author);
        setAuthorData(parsedAuthor);
        GetBlogsByAuthors(parsedAuthor.author_slug);
      }
    }
  }, [post_slug]);
  
  const blogsSchema = Blogdata.map((blog) => ({
    "@type": "BlogPosting",
    headline: blog.post_title,
    image: blog.post_featured_image,
    author: {
      "@type": "Person",
      name: authorData?.name || "Seobix Author",
    },
    datePublished: new Date(blog.created_at).toISOString(),
    url: `${window.location.origin}/blog/${blog.slug}`,
    description: blog.post_excerpt,
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/logo.png", // Replace with your actual logo URL
      },
    },
  }));

  const schemaJSON = authorData
    ? {
        "@context": "https://schema.org",
        "@type": "Person",
        name: authorData.name,
        image: authorData.image,
        jobTitle: "SEO & Marketing Expert | Blogger",
        url: window.location.href,
        worksFor: {
          "@type": "Organization",
          name: "Seobix",
        },
        hasPart: blogsSchema,
      }
    : null;

  return (
    <>
      <Helmet>
        <title>
          {authorData ? `${authorData.name} - Seobix Author` : "Seobix Author"}
        </title>
        <meta
          name="description"
          content={
            authorData
              ? `${authorData.name} writes SEO & Marketing blogs for Seobix. Read their latest articles.`
              : "Seobix Author Page"
          }
        />
        {schemaJSON && (
          <script type="application/ld+json">
            {JSON.stringify(schemaJSON)}
          </script>
        )}
      </Helmet>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        <Nav />
        <div
          style={{
            position: "relative",
            height: "400px",
            background: `linear-gradient(to right, rgba(111, 66, 193, 0.7), rgba(147, 197, 253, 0.7)), url(${seobixBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "2rem",
          }}
        >
          {authorData && (
            <div
              style={{
                background: "#fff",
                borderRadius: "1rem",
                padding: "2rem",
                maxWidth: "500px",
                textAlign: "center",
                boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                position: "relative",
              }}
            >
              <img
                src={authorData.image}
                alt={authorData.name}
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "4px solid #6c63ff",
                  marginTop: "-90px",
                }}
              />

              <h2
                style={{ marginTop: "1rem", fontWeight: 700, color: "#1e1e2f" }}
              >
                {authorData.name}
              </h2>
              <p style={{ color: "#555", marginBottom: "1.5rem" }}>
                SEO & Marketing Expert | Blogger
              </p>

              <div>
                <Button
                  variant="outline-primary"
                  style={{ fontWeight: 600, borderRadius: "50px" }}
                  onClick={scrollToBlogs}
                >
                  View Articles
                </Button>
              </div>
            </div>
          )}
        </div>

        <Blogcontainer Blogdata={Blogdata} blogSectionRef={blogSectionRef} />

        <div
          style={{
            background: "linear-gradient(to right, rgb(175, 221, 255), #fff)",
            borderTopLeftRadius: "2rem",
            borderTopRightRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};
const Blogcontainer = ({ blogSectionRef, Blogdata }) => {
  const BLOGS_PER_CYCLE = 12;
  const [visibleCycles, setVisibleCycles] = React.useState(1);

  const chunkBlogs = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const blogChunks = chunkBlogs(Blogdata, BLOGS_PER_CYCLE);

  const recentBlogs = [...Blogdata]
    .sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    )
    .slice(0, 10);

  return (
    <>
      <div className="row mt-3 p-0 m-0" ref={blogSectionRef}>
        <div className="col-9 mt-5 px-4">
          {blogChunks.slice(0, visibleCycles).map((chunk, index) => (
            <React.Fragment key={index}>
              <div key={index}>
                {chunk[0] && (
                  <Container className="" style={{ marginBottom: "50px" }}>
                    <Card
                      style={{
                        borderRadius: "1rem",
                        overflow: "hidden",
                        boxShadow: "0 15px 35px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Row className="g-0">
                        <div className="col-md-6">
                          <div style={{ width: "100%", aspectRatio: "16 / 9" }}>
                            <img
                              src={chunk[0].post_featured_image}
                              alt={chunk[0].post_title}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                background: "#f3f4f6",
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 p-4">
                          <a
                            href={`/blog/${chunk[0].slug}`}
                            style={{ color: "black", textDecoration: "none" }}
                          >
                            <h5 style={{ fontWeight: 600 }}>
                              {chunk[0].post_title}
                            </h5>
                          </a>
                          <p style={{ color: "#555" }}>
                            {chunk[0].post_excerpt}
                          </p>
                          <a
                            href={`/blog/${chunk[0].slug}`}
                            className="fw-semibold"
                          >
                            Read More →
                          </a>
                        </div>
                      </Row>
                    </Card>
                  </Container>
                )}

                {chunk.length > 1 && (
                  <Container className="mb-3">
                    <Row className="g-4">
                      {chunk[1] && (
                        <div className="col-lg-6 m-0">
                          <Card
                            style={{ borderRadius: "1rem", overflow: "hidden" }}
                          >
                            <div style={{ aspectRatio: "16 / 9" }}>
                              <img
                                src={chunk[1].post_featured_image}
                                alt={chunk[1].post_title}
                                style={{
                                  width: "100%",
                                  objectFit: "contain",
                                  background: "#f3f4f6",
                                }}
                              />
                            </div>
                            <Card.Body className="pt-0 p-2">
                              <a
                                href={`/blog/${chunk[1].slug}`}
                                style={{
                                  color: "black",
                                  textDecoration: "none",
                                }}
                              >
                                <h5>{chunk[1].post_title}</h5>
                              </a>
                              <p
                                className="mb-0"
                                style={{
                                  color: "#555",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 3,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                }}
                              >
                                {chunk[1].post_excerpt}
                              </p>
                            </Card.Body>
                          </Card>
                        </div>
                      )}

                      <div className="col-lg-6 m-0">
                        <Row className="g-2">
                          {chunk.slice(2, 5).map((post) => (
                            <div key={post.post_id} className="col-12">
                              <Card
                                style={{
                                  borderRadius: "1rem",
                                  overflow: "hidden",
                                  cursor: "pointer",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.querySelector(
                                    "img"
                                  ).style.transform = "scale(1.15)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.querySelector(
                                    "img"
                                  ).style.transform = "scale(1)";
                                }}
                              >
                                <Row className="g-0">
                                  <div
                                    className="col-4"
                                    style={{ overflow: "hidden" }}
                                  >
                                    <img
                                      src={post.post_featured_image}
                                      alt={post.post_title}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        transformOrigin: "right center",
                                        transition: "transform .6s ease",
                                      }}
                                    />
                                  </div>
                                  <div className="col-8 p-3">
                                    <a
                                      href={`/blog/${post.slug}`}
                                      style={{
                                        color: "black",
                                        textDecoration: "none",
                                      }}
                                    >
                                      <h6
                                        style={{
                                          fontWeight: 700,
                                          display: "-webkit-box",
                                          WebkitLineClamp: 2,
                                          WebkitBoxOrient: "vertical",
                                          overflow: "hidden",
                                        }}
                                      >
                                        {post.post_title}
                                      </h6>
                                    </a>
                                    <p
                                      style={{
                                        fontSize: ".85rem",
                                        color: "#555",
                                        display: "-webkit-box",
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: "vertical",
                                        overflow: "hidden",
                                      }}
                                    >
                                      {post.post_excerpt}
                                    </p>
                                  </div>
                                </Row>
                              </Card>
                            </div>
                          ))}
                        </Row>
                      </div>
                    </Row>
                  </Container>
                )}

                <Container className="pb-4">
                  <Row className="g-4">
                    {chunk.slice(5, 9).map((post) => (
                      <div key={post.post_id} className="col-lg-3 col-md-6">
                        <Card
                          style={{
                            borderRadius: "1rem",
                            overflow: "hidden",
                            position: "relative",
                            cursor: "pointer",
                            transition:
                              "transform .35s ease, box-shadow .35s ease",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform =
                              "translateY(-8px)";
                            e.currentTarget.style.boxShadow =
                              "0 20px 40px rgba(0,0,0,0.25)";
                            e.currentTarget.querySelector(
                              ".img-zoom"
                            ).style.transform = "scale(1.1)";
                            e.currentTarget.querySelector(
                              ".overlay"
                            ).style.background =
                              "linear-gradient(to top, rgba(0,0,0,.9), rgba(0,0,0,.3))";
                            e.currentTarget.querySelector(
                              ".title"
                            ).style.transform = "translateY(-6px)";
                            e.currentTarget.querySelector(
                              ".title"
                            ).style.opacity = "1";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow =
                              "0 10px 25px rgba(0,0,0,0.12)";
                            e.currentTarget.querySelector(
                              ".img-zoom"
                            ).style.transform = "scale(1)";
                            e.currentTarget.querySelector(
                              ".overlay"
                            ).style.background =
                              "linear-gradient(to top, rgba(0,0,0,.8), rgba(0,0,0,.2))";
                            e.currentTarget.querySelector(
                              ".title"
                            ).style.transform = "translateY(0)";
                            e.currentTarget.querySelector(
                              ".title"
                            ).style.opacity = "0.9";
                          }}
                        >
                          <img
                            className="img-zoom"
                            src={post.post_featured_image}
                            alt={post.post_title}
                            style={{
                              width: "100%",
                              height: "260px",
                              objectFit: "cover",
                              transition: "transform .6s ease",
                            }}
                          />
                          <div
                            className="overlay"
                            style={{
                              position: "absolute",
                              inset: 0,
                              background:
                                "linear-gradient(to top, rgba(0,0,0,.8), rgba(0,0,0,.2))",
                              transition: "background .35s ease",
                            }}
                          />
                          <a
                            href={`/blog/${post.slug}`}
                            style={{ color: "white", textDecoration: "none" }}
                          >
                            <h6
                              className="title"
                              style={{
                                position: "absolute",
                                bottom: "16px",
                                left: "16px",
                                right: "16px",
                                color: "#fff",
                                fontWeight: 700,
                                lineHeight: "1.3",
                                transition:
                                  "transform .35s ease, opacity .35s ease",
                                opacity: 0.9,
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                              }}
                            >
                              {post.post_title}
                            </h6>
                          </a>
                          <a
                            href={`/blog/${post.slug}`}
                            style={{
                              position: "absolute",
                              inset: 0,
                              zIndex: 5,
                            }}
                          />
                        </Card>
                      </div>
                    ))}
                  </Row>
                </Container>

                <Container className="pb-5">
                  <Row className="g-4">
                    {chunk.slice(9, 12).map((post) => (
                      <div key={post.post_id} className="col-lg-4 col-md-6">
                        <Card
                          style={{ borderRadius: "1rem", overflow: "hidden" }}
                        >
                          <img
                            src={post.post_featured_image}
                            alt={post.post_title}
                            style={{
                              width: "100%",
                              height: "180px",
                              objectFit: "cover",
                            }}
                          />
                          <Card.Body>
                            <a
                              href={`/blog/${post.slug}`}
                              style={{ color: "black", textDecoration: "none" }}
                            >
                              <h6>{post.post_title}</h6>
                            </a>
                            <p
                              style={{
                                fontSize: ".9rem",
                                color: "#555",
                                display: "-webkit-box",
                                WebkitLineClamp: 3,
                                WebkitBoxOrient: "vertical",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {post.post_excerpt}
                            </p>
                          </Card.Body>
                        </Card>
                      </div>
                    ))}
                  </Row>
                </Container>
              </div>
            </React.Fragment>
          ))}
          {visibleCycles < blogChunks.length && (
            <div className="text-center mb-5">
              <button
                className="btn btn-outline-dark px-4 py-2"
                style={{ borderRadius: "999px" }}
                onClick={() => setVisibleCycles((prev) => prev + 1)}
              >
                Load More Blogs
              </button>
            </div>
          )}
        </div>

        <div className="col-3 ps-0 pt-3 pe-4">
          <div
            className="mb-5"
            style={{
              position: "sticky",
              top: "20px",
              zIndex: 10,
              background: "#f8f9fa",
              padding: "1rem",
              borderRadius: "10px",
            }}
          >
            <h5 style={{ fontWeight: 800, marginBottom: "20px" }}>
              🕒 Most Recent
            </h5>
            <div style={{ position: "relative", paddingLeft: "18px" }}>
              <div
                style={{
                  position: "absolute",
                  left: "6px",
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  background: "#e5e7eb",
                }}
              />
              {recentBlogs.map((post) => (
                <a
                  key={post.post_id}
                  href={`/blog/${post.slug}`}
                  style={{
                    display: "block",
                    textDecoration: "none",
                    color: "inherit",
                    marginBottom: "26px",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      left: "-14px",
                      top: "4px",
                      width: "10px",
                      height: "10px",
                      borderRadius: "50%",
                      background: "#111",
                    }}
                  />
                  <div
                    style={{
                      fontSize: ".75rem",
                      fontWeight: 600,
                      color: "#666",
                      marginBottom: "6px",
                    }}
                  >
                    {new Date(post.created_at).toLocaleDateString("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })}
                  </div>
                  <div
                    style={{
                      width: "100%",
                      height: "120px",
                      borderRadius: "10px",
                      overflow: "hidden",
                      marginBottom: "8px",
                      background: "#f3f4f6",
                    }}
                  >
                    <img
                      src={post.post_featured_image}
                      alt={post.post_title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <a
                    href={`/blog/${post.slug}`}
                    style={{ color: "black", textDecoration: "none" }}
                  >
                    <h6
                      style={{
                        fontWeight: 700,
                        fontSize: ".9rem",
                        lineHeight: "1.35",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                    >
                      {post.post_title}
                    </h6>
                  </a>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Author;
